"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _response = require("../actions/response");
var _FeedbackResponseState = require("../store/FeedbackResponseState");
var _UIState = _interopRequireDefault(require("../store/UIState"));
function useResponse() {
  var response = (0, _react.useContext)(_FeedbackResponseState.feedbackResponse);
  var responseDispatch = (0, _react.useContext)(_FeedbackResponseState.updateResponse);
  var _useContext = (0, _react.useContext)(_UIState["default"]),
    uiDispatch = _useContext.dispatch;
  var saveFeedbackResponse = (0, _react.useCallback)(function (id, answer) {
    var action = (0, _response.saveResponse)(id, answer);
    responseDispatch(action);
  }, [responseDispatch, response]);
  var initializeResponse = (0, _react.useCallback)(function (questions) {
    var action = (0, _response.initializeResponse)(questions);
    responseDispatch(action);
  }, [_response.initializeResponse, responseDispatch]);
  var submitResponse = (0, _react.useCallback)(function (applicationId, feedbackIntent, userFeedback, sifProfileId) {
    (0, _response.submitResponse)(applicationId, feedbackIntent, userFeedback, sifProfileId)(uiDispatch);
  });
  return {
    response: response,
    saveFeedbackResponse: saveFeedbackResponse,
    submitResponse: submitResponse,
    initializeResponse: initializeResponse
  };
}
var _default = exports["default"] = useResponse;
//# sourceMappingURL=useResponse.js.map